import type { QuoteItemSection, UpdateableLineItem } from '../..'
import type { LineItemOption } from '../../../options'
import { uuid } from '../../../util'

/**
 * Convert a raw line item from options into an updateable line item
 */
export function toUpdateableLineItem({
  lineItemOption,
  quoteType,
  section = 'bid'
}: {
  lineItemOption: LineItemOption
  quoteType: string
  section?: QuoteItemSection
}): UpdateableLineItem {
  return {
    ...lineItemOption,
    type: 'lineItem',
    section,
    quoteType,
    optionKey: lineItemOption?.name ?? '',
    key: uuid(),
    price: lineItemOption?.price ?? 0,
    customHourlyRate: lineItemOption?.customHourlyRate ?? false,
    hourlyRate: lineItemOption?.hourlyRate ?? 0,
    totals: {
      materials: 0,
      afterMaterials: 0
    }
  }
}
